export const NBSP = "\xa0";
export const HAIR_SPACE = "\u200a";

export const PRODUCT_NAME = "Decision Maker";
export const OOC_EMR = `OOC${HAIR_SPACE}/${HAIR_SPACE}EMR`;
